import { ListMenuImportResult } from '../menu-service.types';

export const menuImports: ListMenuImportResult = {
  locationMenuImportSummaryDTOList: [
    {
      requestId: '663df8c4e4fb9c17ca414c81',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '66955a44-3a27-4720-9878-918d502c788a',
      locationTitle: 'Location 1',
      locationExternalId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      userId: '9cebee1f-df3a-46e4-9a73-3de5587b675a',
      menuImportStatus: 'COMPLETED',
      menuDownloadStartedTime: '2024-05-10T10:36:52',
      menuImportCompletedTime: '2024-05-10T10:37:19',
      failureDescription: null,
    },
    {
      requestId: '663df88be4fb9c17ca414c7e',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '39df95a3-439a-4145-9560-aa2ec14d063e',
      locationTitle: 'Location 2',
      locationExternalId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      userId: '9cebee1f-df3a-46e4-9a73-3de5587b675a',
      menuImportStatus: 'IN_PROGRESS',
      menuDownloadStartedTime: '2024-05-10T10:35:55',
      menuImportCompletedTime: '2024-05-10T10:36:03',
      failureDescription: null,
    },
    {
      requestId: '662a121ee11ea74baea65bcc',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '063eaaea-8d0b-49f8-8e1d-b97b45c9a86c',
      locationTitle: 'Location 3',
      locationExternalId: null,
      userId: '3195034b-e23f-4ced-88ed-c7eecf621770',
      menuImportStatus: 'FAILED',
      menuDownloadStartedTime: '2024-04-25T08:19:42',
      menuImportCompletedTime: null,
      failureDescription: '',
    },
    {
      requestId: '66267b4de11ea74baea65a09',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      locationTitle: 'Location 4',
      locationExternalId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      userId: 'POS-Sync',
      menuImportStatus: 'COMPLETED',
      menuDownloadStartedTime: '2024-04-22T14:59:25',
      menuImportCompletedTime: '2024-04-22T14:59:49',
      failureDescription: null,
    },
    {
      requestId: '663cb825f48e1f6a5f0ffdb2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: 'a8c7020b-27ff-4373-9896-abc4f41d3f59',
      locationTitle: 'Location 5',
      locationExternalId: '2',
      userId: '339f1067-9064-4aa8-a061-546fb42e8f35',
      menuImportStatus: 'COMPLETED',
      menuDownloadStartedTime: '2024-05-09T11:48:54',
      menuImportCompletedTime: '2024-05-09T11:49:08',
      failureDescription: null,
    },
    {
      requestId: '66268424e11ea74baea65a13',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: 'f8321420-7a9c-4ded-9d18-71b0f5fe0b40',
      locationTitle: 'Location 6',
      locationExternalId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      userId: '339f1067-9064-4aa8-a061-546fb42e8f35',
      menuImportStatus: 'COMPLETED',
      menuDownloadStartedTime: '2024-04-22T15:37:08',
      menuImportCompletedTime: '2024-04-22T15:37:16',
      failureDescription: null,
    },
    {
      requestId: '663e0e15e4fb9c17ca414c87',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '6367bbe2-4ed0-4c4a-98be-3d8f430f1384',
      locationTitle: 'Location 7',
      locationExternalId: 'Location3479',
      userId: 'POS-Sync',
      menuImportStatus: 'FAILED',
      menuDownloadStartedTime: '2024-05-10T12:07:49',
      menuImportCompletedTime: null,
      failureDescription:
        'RestClientException: Error while extracting response for type [java.util.List<com.incentivio.connector.spoton.api.menu.domain.MenuDescriptor>] and content type [application/json]; nested exception is org.springframework.http.converter.HttpMessageNotReadableException: JSON parse error: Cannot deserialize value of type `java.util.ArrayList<com.incentivio.connector.spoton.api.menu.domain.MenuDescriptor>` from Object value (token `JsonToken.START_OBJECT`); nested exception is com.fasterxml.jackson.databind.exc.MismatchedInputException: Cannot deserialize value of type `java.util.ArrayList<com.incentivio.connector.spoton.api.menu.domain.MenuDescriptor>` from Object value (token `JsonToken.START_OBJECT`)\n at [Source: (org.springframework.util.StreamUtils$NonClosingInputStream); line: 1, column: 1]',
    },
    {
      requestId: '6638bb4858d73b2036db554d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: 'd8cc04d1-a4fa-4eec-b042-0ac70501c043',
      locationTitle: 'Location 8',
      locationExternalId: null,
      userId: '339f1067-9064-4aa8-a061-546fb42e8f35',
      menuImportStatus: 'COMPLETED',
      menuDownloadStartedTime: '2024-05-06T11:13:12',
      menuImportCompletedTime: '2024-05-06T11:13:50',
      failureDescription: null,
    },
    {
      requestId: '663dc61fe4fb9c17ca41420c',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '06f3898b-3148-4ea4-a644-a129a35270d9',
      locationTitle: 'Location 9',
      locationExternalId: '504',
      userId: 'POS-Sync',
      menuImportStatus: 'COMPLETED',
      menuDownloadStartedTime: '2024-05-10T07:00:47',
      menuImportCompletedTime: '2024-05-10T07:00:57',
      failureDescription: null,
    },
    {
      requestId: '6630b06c2b1c1618878ef1b0',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '5e0dab8c-af8e-40f3-aaed-c9bccda327c8',
      locationTitle: 'Location 10',
      locationExternalId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      userId: '3195034b-e23f-4ced-88ed-c7eecf621770',
      menuImportStatus: 'NEW',
      menuDownloadStartedTime: '2024-04-30T08:48:44',
      menuImportCompletedTime: '2024-04-30T08:48:54',
      failureDescription: null,
    },
  ],
  paging: {
    total: 100,
    count: 10,
    totalPages: 10,
    currentPage: 0,
  },
};
